import { Col, Row, Select, Spin } from "antd";
import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import FeedCard from "../../common/cards/FeedCard";
import Loader from "../../common/cards/Loader";
import NoData from "../../common/cards/noData";
import { useFetchAllTipsAndTricks } from "../../common/hooks/useFetchAllTipsAndTricks";

import "./tips-and-tricks.css";
import {
  E_SPORTS_LIST,
  PHYSICAL_SPORTS_LIST,
  SPORTS_TYPES,
  SPORTS_TYPES_LIST
} from "../../Config/helpers/constants";

function TipsAndTricks() {
  const [posts, setPosts] = useState([]);
  const [loadMorePosts, setLoadMorePosts] = useState(false);
  const [type, setType] = useState("");
  const [sportType, setSportType] = useState("");
  const [sportName, setSportName] = useState("");

  const observer = useRef();
  const timer = useRef();
  const isThrottled = useRef(false);

  const { fetchloading, POSTS, setPage, totalPages, page, fetchTime, GetAllPosts } =
    useFetchAllTipsAndTricks("player", { type, sportName });

  useEffect(() => {
    const fetchPosts = async () => {
      setPosts([...POSTS]);

      // Adjust timeout based on fetch time, adding some buffer (e.g., 100ms)
      const timeoutDuration = Math.max(fetchTime + 100, 500); // Minimum of 500ms

      timer.current = setTimeout(() => setLoadMorePosts(false), timeoutDuration);
    };
    fetchPosts();
    return () => clearTimeout(timer.current);
  }, [POSTS, fetchTime]);

  useEffect(() => {
    GetAllPosts();
  }, [type, sportName, setPage]);

  const lastPostElementRef = useCallback(
    (node) => {
      if (fetchloading || isThrottled.current) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setLoadMorePosts(true);
            isThrottled.current = true;
            setTimeout(() => {
              isThrottled.current = false;
            }, 100);
            if (page < totalPages) setPage((prevPage) => prevPage + 1);
          }
        },
        {
          root: null,
          threshold: 0.1
        }
      );
      if (node) observer.current.observe(node);
    },
    [fetchloading, page, totalPages]
  );

  return (
    <Row justify="center" className="rowPaddingHome">
      <Col
        xs={{ span: 24, order: 3 }}
        sm={{ span: 24, order: 3 }}
        md={{ span: 24, order: 3 }}
        lg={{ span: 11, order: 2 }}>
        <h1>Tips & Tricks</h1>
        <Row className="mobileto">
          <div className="filterSection">
            <Select
              placeholder={"Select Sports Type"}
              onChange={(e) => {
                setSportType(e);
              }}
              options={SPORTS_TYPES_LIST}
              defaultValue={SPORTS_TYPES.eSports}
            />
            <Select
              placeholder={"Name of Sport"}
              onChange={(e) => {
                setSportName(e);
              }}
              allowClear>
              {/* render physical sports  */}
              {sportType === SPORTS_TYPES.physicalSports
                ? PHYSICAL_SPORTS_LIST.map((sport, index) => (
                    <Select.Option key={index} value={sport.value}>
                      {sport.label}
                    </Select.Option>
                  ))
                : E_SPORTS_LIST.map((sport, index) => (
                    <Select.Option key={index} value={sport.value}>
                      {sport.label}
                    </Select.Option>
                  ))}
            </Select>
            <Select placeholder={"Select Sports Type"} onChange={(e) => setType(e)} allowClear>
              <Select.Option key={"1"} value={""}>
                {"Tips & Tricks"}
              </Select.Option>
              <Select.Option key={"2"} value={"tip"}>
                {"Tips"}
              </Select.Option>
              <Select.Option key={"#"} value={"trick"}>
                {"Tricks"}
              </Select.Option>
            </Select>
          </div>
          {fetchloading ? (
            <Loader />
          ) : posts?.length > 0 ? (
            <>
              {posts?.map((data, index) => (
                <FeedCard
                  key={data?._id || index}
                  index={index}
                  data={data}
                  POSTS={posts}
                  setPOSTs={setPosts}
                  ref={posts.length === index + 1 ? lastPostElementRef : null}
                />
              ))}

              {/* Loader for more posts */}
              {loadMorePosts && page < totalPages && (
                <div style={{ textAlign: "center", margin: "20px", width: "100%" }}>
                  <Spin tip="Loading more posts..." style={{ color: "black", fontSize: "12px" }} />
                </div>
              )}
            </>
          ) : (
            <NoData />
          )}
        </Row>
      </Col>
    </Row>
  );
}

export default TipsAndTricks;
